export const createColorSlice = (set) => ({
  colorScheme: 'home',
  setColorScheme: (value) => set({ colorScheme: value }),
})